// Styles
import 'vuetify/dist/vuetify.min.css'
import 'fullcalendar/dist/fullcalendar.css'

// Helpers
import colors from 'vuetify/es5/util/colors'

import App from '@/App'
import EmptyAlert from '@/modules/EmptyAlert'

// Libraries
import Vue from 'vue'
import Vuetify from 'vuetify'
import vueCustomElement from 'vue-custom-element'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import FullCalendar from 'vue-full-calendar'
import VueYouTubeEmbed from 'vue-youtube-embed'
import TreeView from 'vue-json-tree-view'
// eslint-disable-next-line
import Amplify, { Storage, Auth } from 'aws-amplify'
import awsExports from './aws-exports'
// import EventBus from '@/event-bus'
Amplify.configure(awsExports)

// moment
const moment = require('moment')
require('moment/locale/pt-br')

// eslint-disable-next-line
import API from '@/api'
window.qs = require('qs')

// Directives
require('@/directives/ModalTrigger')

// Filters
require('@/filters/FormatNumber')
require('@/filters/FormatCurrency')

// Vue Use
Vue.use(Vuex)
Vue.use(Vuetify, {
  theme: {
    success: colors.teal.accent4
  }
})

Vue.use(VueYouTubeEmbed)
Vue.use(VueAxios, axios)
Vue.use(vueCustomElement)
Vue.use(require('vue-moment'), {
  moment
})
Vue.use(FullCalendar)
Vue.use(TreeView)
Vue.component('empty-alert', EmptyAlert)

// Config
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created () {
    const currentToken = localStorage.getItem('currentToken')

    if (currentToken) axios.defaults.headers.common['Authorization'] = currentToken
  }
})



// WEBPACK FOOTER //
// ./src/main.js